import { getRoomTag } from '../../../../../../modules/room-tag-storage.js';
import { emptyCateringOptions } from '../misc/cateringOptions.js';

const config = window._VUE_ROOM_CONFIG;
const eventType = getRoomTag();

const STEPS = {
  dateAndPeople: 'dateAndPeople',
  messageAndCatering: 'messageAndCatering',
  userInfo: 'userInfo',
};

const state = {
  socialAuthMethod: null,
  roomSetupAllowsOP: null,
  requestToBookPath: false, // is following OP path within OPFlow
  requestToBookMobilePath: false,
  minimumPricing: null,
  STEPS,
  step: STEPS.dateAndPeople,
  pricing: {
    loading: false,
    paymentDetails: null,
  },
  manager: {
    id: config.manager.id,
    shortName: config.manager.shortname,
    firstName: config.manager.firstName,
    photo: config.manager.photo,
    hasPhone: config.manager.hasPhone,
  },
  venue: {
    id: config.venueId,
    name: config.venueName,
    isSuperVenue: config.isSuperVenue || false,
    responseRate: null,
    responseTime: null,
  },
  form: {
    dateAndPeople: {
      eventType,
      date: '',
      people: '',
      timeFrom: null,
      timeTo: null,
      flexibleOnTime: false,
      layout: null,
    },
    messageAndCatering: {
      message: '',
      catering: {
        requireCatering: false,
        ownCatering: false,
        ...emptyCateringOptions,
      },
      extendedCatering: {
        seatedMeal: false,
        buffet: false,
        canapes: false,
        drinksReception: false,
        openBar: false,
      },
    },
    userInfo: {
      fullName: '',
      email: '',
      password: '',
      phone: '',
      marketingConsent: false,
    },
  },
  room: {
    id: config.roomId,
    name: config.roomName,
    mainPhoto: config.mainPhoto,
    minHoursForBooking: config.minimumHoursForBooking,
    leadHubOffer: null,
    availability: {
      partiallyBookedDays: [],
      fullyBookedDays: [],
      closedDaysOfWeek: [],
      openingHours: {},
      hoursFlexibility: config.hoursFlexibility,
    },
    capacity: {
      min: config.minAttendeesPerEvent,
      max: config.maxCapacity,
      standing: config.maxStandingCapacity,
      sitting: config.maxSittingCapacity,
    },
    catering: {
      availableByVenue: false,
      availableExternal: false,
    },
    eventOfferName: config.eventOfferName,
  },
  pages: {
    ...config.pages,
    enquirySearchPageUrl: config.enquirySearchPageUrl,
    requestToBookFlow: config.requestToBookFlow,
  },
  user: {
    isLoggedIn: false,
    searchedEventType: eventType,
    lastEnquiry: {
      date: '',
      url: '',
    },
  },
  api: {
    token: config.quickEstimate.token,
    sendEnquiry: config.quickEstimate.actionUrl,
    roomInfo: config.apiUrl,
    fetchLastRfpDataUrl: config.fetchLastRfpDataUrl,
    auth: config.authUrl,
    validateEmail: config.verifyEmailRoute,
    roomPricingRoute: config.roomPricingRoute,
    lowestPriceRoute: config.lowestPriceRoute,
    gAuth: {
      url: config.quickEstimate.googleUrl,
      clientId: config.quickEstimate.googleClientId,
    },
    facebookAuth: config.quickEstimate.facebookUrl,
  },
  isLoading: {
    sendEnquiry: false,
  },
  captcha: {
    sitekey: config.captcha.sitekey,
    isEnabled: false,
    token: null,
  },
  referrer: window.document.referrer,
  eventTypes: [],
  isBigDesktop: true,

  l10n: config.l10n,
  gAuth: {
    errorMessage: '',
  },
  showSuspensionWarning: config.showSuspensionWarning,
  isVenueSuspended: config.showSuspensionWarning,
  suspensionProblemIds: config.suspensionProblemIds,
  suspensionProblemsMap: config.suspensionProblemsMap,
  companyId: config.companyId,
  isEnquiryFormModalOpen: false,
  noticeHours: 0,
  enquirySentModalConfig: null,
  responseTime: config.responseTime,
  responseRate: config.responseRate,
  pricingsLiquidityIndicators: config.pricingsLiquidityIndicators,
  managerLastActivityOnline: null,
  map: config.map,
};
export default state;
